import { $UserAgent } from '@lemon8/web-app-shared/atom';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { getTodayAndMondayDate } from 'shared/utils/format/time-formatter';
import { $SEOKepAddDate } from '~/utils/libra/seo-kep-date-exp';

export const UpdatedDate = () => {
  const { t } = useTranslation();
  const { isBot } = useAtomValue($UserAgent);

  const seoKepAddDate = useAtomValue($SEOKepAddDate);

  if (seoKepAddDate === 'v0') {
    return null;
  }

  const { monday, mondayInSlashFormat } = getTodayAndMondayDate();

  return <time dateTime={monday}>{t('seo_kep_timeStamp').replace('%s', isBot ? monday : mondayInSlashFormat)}</time>;
};
